import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ViewportDetect from '@djforth/viewport-detection-fp';

import { ChangeDevice } from '../../actions/general';

export class ResizerCompenent extends PureComponent {
  static propTypes = {
    DeviceChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { DeviceChange } = this.props;
    this.vpDetect = ViewportDetect();
    this.vpDetect.addCallback(device => {
      DeviceChange(device);
    });
    this.vpDetect.track();
    DeviceChange(this.vpDetect.getDevice());
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ sessions }) => ({
  sessions: sessions.items,
});

const mapDispatchToProps = dispatch => ({
  DeviceChange: device => dispatch(ChangeDevice(device)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResizerCompenent);
